import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './GlowPeel.css';

function GlowPeel() {
  const { t } = useTranslation();

  return (
    <div className="glow-peel-page">
      {/* Hero Section */}
      <section className="glow-peel-hero">
        <div className="container">
          <h1>Glow Peel — Instantly Brighter, Smooth & Radiant Skin</h1>
          <p className="hero-subtitle">
            The Glow Peel is a gentle yet effective resurfacing treatment designed to restore luminosity, 
            refine texture, and boost hydration — perfect before special events or whenever your skin needs 
            an instant pick-me-up.
          </p>
          <p className="hero-note">
            Suitable for all skin types, including sensitive skin.
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="glow-peel-content">
        <div className="container">
          <div className="content-wrapper">
            {/* What's Included */}
            <div className="content-section">
              <h2>What's Included</h2>
              <ul className="included-list">
                <li>Deep double cleanse</li>
                <li>Light enzyme or acid exfoliation (customised)</li>
                <li>Glow Peel application</li>
                <li>Hydrating and brightening mask</li>
                <li>Nourishing moisturiser and SPF</li>
              </ul>
            </div>

            {/* Benefits */}
            <div className="content-section">
              <h2>Benefits of the Glow Peel</h2>
              <ul className="benefits-list">
                <li>Reveals immediate glow and radiance</li>
                <li>Smooths fine lines and rough texture</li>
                <li>Minimises pores and congestion</li>
                <li>Brightens dull, uneven complexion</li>
                <li>Enhances makeup application</li>
                <li>Little to no downtime</li>
              </ul>
              <div className="highlight-note">
                <p>
                  <strong>A brilliant treatment to boost confidence and refresh your skin's natural beauty.</strong>
                </p>
              </div>
            </div>

            {/* Sessions Needed */}
            <div className="content-section">
              <h2>How Many Sessions Do I Need?</h2>
              <p>
                <strong>One-off:</strong> Ideal as a one-off for special occasions
              </p>
              <p>
                <strong>Course:</strong> 4–6 treatments every 2–4 weeks recommended for lasting radiance
              </p>
            </div>

            {/* Not Suitable */}
            <div className="content-section">
              <h2>Not Suitable If You Are:</h2>
              <ul className="not-suitable-list">
                <li>Pregnant or breastfeeding (depending on peel strength used)</li>
                <li>Using retinol or strong actives within the last 7 days</li>
                <li>Taking prescribed acne medication</li>
                <li>Experiencing cold sores, active acne infection, eczema or psoriasis flare</li>
                <li>Recently had fillers or Botox (within 2 weeks)</li>
              </ul>
              <p className="suitability-note">
                <em>Suitability confirmed during consultation.</em>
              </p>
            </div>

            {/* Managing Side Effects */}
            <div className="content-section">
              <h2>Managing Side Effects</h2>
              <p>
                Side effects are typically minimal and short-term:
              </p>
              <ul className="side-effects-list">
                <li>Mild redness or warmth</li>
                <li>Light tightening sensation</li>
                <li>Occasional flaking as skin renews</li>
                <li>Minor sensitivity</li>
              </ul>
              <div className="side-effects-note">
                <p>
                  <em>These are normal responses as the skin gently exfoliates and renews.</em>
                </p>
              </div>
            </div>

            {/* Post-Treatment Care */}
            <div className="content-section">
              <h2>Post-Treatment Care</h2>
              <h3>For the first 24–48 hours:</h3>
              <ul className="aftercare-list">
                <li>Avoid direct sunlight</li>
                <li>Use SPF 30+ daily</li>
                <li>Avoid heavy exercise, steam rooms, and saunas</li>
                <li>Avoid swimming pools</li>
                <li>Gentle cleansing only</li>
                <li>Keep the skin well-hydrated</li>
                <li>Avoid makeup for 24 hours</li>
              </ul>
            </div>

            {/* CTA Section */}
            <div className="cta-section">
              <h2>{t('services.cta.title')}</h2>
              <p>{t('services.cta.description')}</p>
              <div className="cta-buttons">
                <a href="https://widget.treatwell.co.uk/place/beauty-lounge-green-canning-town/" target="_blank" rel="noopener noreferrer" className="cta-button primary">{t('services.cta.button')}</a>
                <Link to="/services" className="cta-button secondary">Back to Services</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default GlowPeel;

